import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AuthModule } from '../../../../auth/auth.module';
import { CartModule } from '../../../../cart/cart.module';
import { NotificationModule } from '../../../../notification/notification.module';
import { SharedDirectivesModule } from '../../../directives/shared-directives.module';
import { ConnectionMonitorModule } from '../../../services/connection-service/connection-monitor.module';
import { ReloadPageModule } from '../../reload-page/reload-page.module';
import { SharedComponentsModule } from '../../shared-components.module';
import { RightNavBarComponent } from './right-nav-bar.component';

@NgModule({
    declarations: [RightNavBarComponent],
    imports: [
        AuthModule,
        BsDropdownModule,
        CartModule,
        CommonModule,
        ConnectionMonitorModule,
        NotificationModule,
        ReloadPageModule,
        RouterModule,
        SharedComponentsModule,
        SharedDirectivesModule
    ],
    exports: [RightNavBarComponent]
})
export class RightNavBarModule {
}
